import React, { useEffect, useMemo, useRef, useState } from "react";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { Dropdown } from "../../components/CustomFormElements/syncFusionFormFields";
import moment from "moment";
import { setBreadCrumb } from "middleware/actions/breadCrumbAction";
import { DateRangePickerComponent } from "@syncfusion/ej2-react-calendars";
import { fetchAccessUsage } from "middleware/services/reportApi";
import { enableRipple } from "@syncfusion/ej2-base";
import { hideLoader, showLoader } from "middleware/actions/utilityAction";
import TreeDataGridNew from "app/components/treeDataGridNew";
import { ColumnDirective, ColumnsDirective } from "@syncfusion/ej2-react-grids";
import { StringFilter } from "app/components/dataGrid/fliters";
import NewPagination from "app/components/newPagination/newPagination";
import * as CONSTANTS from "../../../constants/index";
import "./style.scss";
import { presets } from "utils";

// specify breadcrumb here
const breadCrumbLinks = [{ linkUrl: "/report/internal-user", linkName: "Internal User Report", linkActive: true }];
enableRipple(true);

const AccessUsageReport = (props) => {
  const dispatch = useDispatch();
  const [dateRange, setDateRange] = useState(null);
  const [startDate, setStartDate] = useState(moment(new Date()).format("dd-MMM-yyyy"));
  const [endDate, setEndDate] = useState(moment(new Date()).format("dd-MMM-yyyy"));
  const [rowData, setRowData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const showLoaderGrid = () => dispatch(showLoader());
  const hideLoaderGrid = () => dispatch(hideLoader());
  const gridState = useSelector((state) => state.gridState);
  const [gridRef, setGridRef] = useState(null);

  const formik = useFormik({
    initialValues: {
      sharableContentSharedVia: "All",
    },
  });

  //** Fetch ask your analyst report
  const fetchAccessUsageReport = async (reportDateRange = null, params = {}, state = false) => {
    try {
      dispatch(showLoader());
      params.filters = [];
      params.sort = "sharableContentSharedOn:desc";
      if (gridState?.recordsPerPage) params.limit = gridState.recordsPerPage;
      const DateFilter = dateRange === null ? reportDateRange : dateRange;

      if (DateFilter && Array.isArray(DateFilter)) {
        const [startDate, endDate] = DateFilter;

        const gte = { d: moment(startDate).toISOString() };
        const lt = { d: moment(endDate).add(1, "day").toISOString() };

        params.filters.push(["sharableContentSharedOn", "gte", gte.d]);
        params.filters.push(["sharableContentSharedOn", "lt", lt.d]);
      }

      if (state && formik.values.sharableContentSharedVia !== "All" && formik.values.sharableContentSharedVia !== null)
        params.filters.push(["sharableContentSharedVia", "eq", formik.values.sharableContentSharedVia]);

      const response = await fetchAccessUsage(params);
      setRowData(response?.data.data);
      setTotalCount(response?.data.totalCount);
      dispatch(hideLoader());
    } catch (err) {
      console.log("error:::::::::", err);
      dispatch(hideLoader());
    }
  };

  //** handle reset function
  const handleReset = () => {
    window.location.reload();
  };

  //** handle date range
  const fnStartDate = () => {
    let dateFrom = new Date();
    let dateTo = new Date();
    dateFrom.setDate(dateFrom.getDate() - CONSTANTS.BOREPORTDEFAULTDATERANGE);
    const dateStart = dateFrom
      .toLocaleDateString("en-GB", {
        day: "numeric",
        month: "short",
        year: "numeric",
      })
      .replace(/ /g, "-");
    dateTo.setDate(dateTo.getDate());
    const dateEnd = dateTo
      .toLocaleDateString("en-GB", {
        day: "numeric",
        month: "short",
        year: "numeric",
      })
      .replace(/ /g, "-");
    setStartDate(new Date(dateStart));
    setEndDate(new Date(dateEnd));
    setDateRange([dateFrom, dateTo]);
    return [dateFrom, dateTo];
  };

  const getGridRef = (gridRefData) => {
    setGridRef(gridRefData);
  };

  useEffect(() => {
    (async () => {
      const reportDateRange = fnStartDate();
      await fetchAccessUsageReport(reportDateRange);
      hideLoader();
    })();
  }, []);

  //** Set breadcrumb
  useEffect(() => {
    dispatch(setBreadCrumb(breadCrumbLinks));
    return () => {
      dispatch(setBreadCrumb());
    };
  }, [dispatch]);

  const handleCreated = () => {
    showLoaderGrid();
    if (gridRef?.current) {
      gridRef.current.grid.columnChooserSettings.operator = "contains";
    }
  };

  return (
    <div className="px-3 grid-bg-white data-report-container">
      <div className="col-md-12 rounded-bottom nopadding p-0 bg-white ">
        <div className="row">
          <div className="col-md-2 mt-3 pr-0 grid-container-report-filters">
            <Dropdown
              formik={formik}
              placeholder="Content Type"
              required="required"
              id="sharableContentSharedVia"
              name="sharableContentSharedVia"
              fields={{ text: "label", value: "value" }}
              value={formik.values.sharableContentSharedVia}
              dataSource={CONSTANTS.SHARED_VIA_DATA_SOURCE}
            />
          </div>
          <div className="col-md-2 mt-3 grid-container-report-filters pr-0 responsive-report-filters">
            <DateRangePickerComponent
              placeholder="Shared On"
              cssClass="e-outline user-traffic-datepicker"
              openOnFocus={true}
              showClearButton={false}
              format="dd MMM yyyy"
              separator="to"
              floatLabelType="Auto"
              startDate={startDate}
              endDate={endDate}
              onChange={(e) => {
                if (e.value) setDateRange(e.value);
              }}
              autoComplete="off"
              max={new Date()}
              strictMode={true}
              presets={presets}
            />
          </div>

          <div className="col-md-3 mt-3">
            <button type="button" onClick={() => fetchAccessUsageReport(null, {}, true)} className="search-btn px-4 btn btn-primary mr-2">
              Search
            </button>
            <button type="reset" onClick={handleReset} className="btn btn-outline-dark px-4 ml-2 ">
              Reset
            </button>
          </div>
        </div>
      </div>
      <div className="gennx-grid-client-detail-report analyst-query-report-grid">
        <TreeDataGridNew
          rowData={rowData}
          isPaging={false}
          showResetFilter={true}
          deleteMany={false}
          allowPagination={true}
          showExportButton={true}
          showLoader={showLoaderGrid}
          hideLoader={hideLoaderGrid}
          exportFileName={"Access & Usage Report"}
          getGridRef={getGridRef}
          created={handleCreated}
        >
          <ColumnsDirective>
            <ColumnDirective
              field="sharableContentName"
              headerText="Content Name"
              filterTemplate={StringFilter}
              type="String"
              textAlign="Left"
              width={window.innerWidth < 1366 ? "180px" : "260px"}
              minWidth={window.innerWidth < 1366 ? "180px" : "260px"}
              maxWidth={window.innerWidth < 1366 ? "180px" : "260px"}
              clipMode="EllipsisWithTooltip"
              showInColumnChooser={false}
            />
            <ColumnDirective
              field="sharableContentType"
              headerText="Content Type"
              filterTemplate={StringFilter}
              type="String"
              textAlign="Left"
              width={window.innerWidth < 1366 ? "100px" : "150px"}
              minWidth={window.innerWidth < 1366 ? "100px" : "150px"}
              maxWidth={window.innerWidth < 1366 ? "100px" : "150x"}
              clipMode="EllipsisWithTooltip"
              showInColumnChooser={false}
            />
            <ColumnDirective
              field="sharableShortLink"
              headerText="Link"
              filterTemplate={StringFilter}
              type="String"
              textAlign="Left"
              width={window.innerWidth < 1366 ? "170px" : "240px"}
              minWidth={window.innerWidth < 1366 ? "170px" : "240px"}
              maxWidth={window.innerWidth < 1366 ? "170px" : "240px"}
              clipMode="EllipsisWithTooltip"
            />
            <ColumnDirective
              field="shortLinkCreatedBy.userEmail"
              headerText="Shared By"
              filterTemplate={StringFilter}
              type="String"
              textAlign="Left"
              width={window.innerWidth < 1366 ? "150px" : "230px"}
              minWidth={window.innerWidth < 1366 ? "150px" : "230px"}
              maxWidth={window.innerWidth < 1366 ? "150px" : "230px"}
              clipMode="EllipsisWithTooltip"
            />
            <ColumnDirective
              field="sharableContentSharedVia"
              headerText="Shared Via"
              filterTemplate={StringFilter}
              type="String"
              textAlign="Left"
              width={window.innerWidth < 1366 ? "50px" : "100px"}
              minWidth={window.innerWidth < 1366 ? "50px" : "100px"}
              maxWidth={window.innerWidth < 1366 ? "50px" : "100px"}
              clipMode="EllipsisWithTooltip"
            />
            <ColumnDirective
              field="shortLinkCreatedOn"
              headerText="Shared On"
              width="130px"
              minWidth="130px"
              maxWidth="130px"
              type="date"
              format={{ type: "date", format: "dd-MMM-yyyy" }}
              textAlign="Center"
              headerTextAlign="Left"
              clipMode="EllipsisWithTooltip"
            />
            <ColumnDirective
              field="sharableContentAccessedBy.userEmail"
              headerText="Shared With"
              filterTemplate={StringFilter}
              type="String"
              textAlign="Left"
              width={window.innerWidth < 1366 ? "180px" : "260px"}
              minWidth={window.innerWidth < 1366 ? "180px" : "260px"}
              maxWidth={window.innerWidth < 1366 ? "180px" : "260px"}
              clipMode="EllipsisWithTooltip"
            />
            <ColumnDirective
              field="contentAccess"
              headerText="Access"
              filterTemplate={StringFilter}
              type="String"
              textAlign="Left"
              width={"100px"}
              clipMode="EllipsisWithTooltip"
              valueAccessor={() => "Yes"} // Always returns "Yes"
            />
            <ColumnDirective
              field="visitDetails.sharableContentAccessOn"
              headerText="Accessed On"
              width="130px"
              minWidth="130px"
              maxWidth="130px"
              type="date"
              format={{ type: "date", format: "dd-MMM-yyyy" }}
              textAlign="Center"
              headerTextAlign="Left"
              clipMode="EllipsisWithTooltip"
            />
            <ColumnDirective
              field="visitDetails.sharableContentSpentDuration"
              headerText="Duration Spent (Min)"
              filterTemplate={StringFilter}
              type="String"
              textAlign="Left"
              width="160px"
              minWidth="160px"
              maxWidth="160px"
              clipMode="EllipsisWithTooltip"
            />
          </ColumnsDirective>
        </TreeDataGridNew>
        <NewPagination
          rowData={rowData}
          allowPagination={true}
          showLoader={showLoaderGrid}
          hideLoader={hideLoaderGrid}
          totalCount={totalCount}
          setRowData={setRowData}
          fetch={fetchAccessUsageReport}
          defaultPageView={CONSTANTS.DEFAULTANALYSTREPORTPAGEVIEW}
        />
      </div>
    </div>
  );
};

export default AccessUsageReport;
